<!-- 住宅部超过24小时或7天未完成审批报备表 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled"  v-bind:loading="formLoading" size="large" type="primary">
			提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import stringUtils from "../assets/js/stringUtil.js";
	import Choose from '../components/Choose.vue';
    import { getTemplateInfo,submitProcess } from '@/api/approval'
	import { getRelation } from '@/api/employee'
	import { formatDate } from '@/utils/date'
	import wx from 'weixin-js-sdk'
	import {
		initWxConfig
	} from '../api/jssdk.js';
	

	var isSubmit = false;
	var userInfo = null; // 使用者信息
	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	
	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'
	
	import {
		getUserInfo,
		getAgentInfo
	} from '@/api/employee'
	

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading:false,
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			clickChoose(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values = [];
						dataVal.Value = depart.name;
						dataVal.Values.push([depart.id, depart.name]);
						getDepartmentInfo(depart.id).then(async res => {
							var departFullName = res.Body.FullName;
							var ApiDep = departFullName;
							var departName = departFullName.split("/");
							that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
								if(departName.indexOf("住宅部") > -1 || departName.indexOf("住宅行政支持组") > -1 || departName.indexOf("住宅部支援中心") > -1){
									if (item.Property.Title[0].Text == "行政主任") {
										item.Values = [];
										item.Values = await that.getDepartmentRelation(depart.id, "行政主任");
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(["SC24000029", "钟志斌"]);
										}
									}
									if (item.Property.Title[0].Text == "行政经理") {
										item.Values = [];
										item.Values = await that.getDepartmentRelation(depart.id, "行政经理");
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(["SC24000029", "钟志斌"]);
										}
									}
									if(item.Property.Title[0].Text == "分行行政"){
										item.Values = await that.getDepartmentRelation(depart.id, "行政助理");
										if(item.Values == null || item.Values.length == 0){
											item.Values = await that.getDepartmentRelation(depart.id, "行政主管");
											if(item.Values == null || item.Values.length == 0){
												item.Values = await that.getDepartmentRelation(depart.id, "行政主任");
											}
										}
									}
									if (item.Property.Title[0].Text == "小战区区董") {
										item.Values = [];
										item.Values = await that.getDepartmentRelation(depart.id, "区域董事", true);
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(["SC24000029", "钟志斌"]);
										}
									}
									if (item.Property.Title[0].Text == "大战区区董") {
										item.Values = [];
										item.Values = await that.getDepartmentRelation(depart.id, "大区董事", true);
										if(departFullName.indexOf("直带大战区")>-1){
											//item.Values = await that.getDepartmentRelation(depart.id, "总经理", true);
											//2021-9-3张彬离职临时修改
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											
											item.Values.push(["SC18006783", "王万华"]);
										}
									}
								}else{
									if (item.Property.Title[0].Text == "经理/总监") {
										item.Values = [];
										item.Values = await that.getDepartmentRelationList(depart.id,5, "经理",false);
										
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											//小部门的总经理
											item.Values = await that.getDepartmentRelationList(depart.id,7, "总监",false);
											
										}
										if (departFullName.indexOf("华西区/房友圈/联动拓展部") > -1) {
											item.Values = await that.getDepartmentRelationList(depart.id,7, "联动拓展总经理");
										}
										if (item.Values == null || item.Values.length <= 0) {
											//审批节点无人，跳过
											item.Values.push(["SC24000029", "钟志斌"]);
										}
										item.IsShow = false;
									}
									if (item.Property.Title[0].Text == "总经理") {
										item.Values = [];
										await getDepartmentRelationByName(departFullName, false).then(res => {
											if (res.Body != null) {
												for (var i = 0; i < res.Body.length; i++) {
													res.Body[i].Nodes.forEach((depData) => {
														if (depData.Items != null) {
															depData.Items.forEach((userData) => {
																if (userData.PositionName.indexOf("总经理") > -1&&userData.JobLevel>5) {
																	if (item.Values == null || item.Values.length == 0) {
																		var insertDat = [userData.EmpNo, userData.EmpName]
																		item.Values.push(insertDat);
																		return;
																	}
																}
															})
														}
													});
												}
											} else {
												item.Values = [
													["SC24000029", "钟志斌"]
												]
											}
											if (item.Values == null || item.Values.length == 0) {
												item.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									
									}
								}
								if (item.Property.Title[0].Text == "逐级审批") {
									item.Values = [];
									item.IsShow = false;
									await getDepartmentRelationById(res.Body.DeptId).then(data => {
										if (data.Body != null && data.Body.length > 0) {
											for(var i = 0;i < data.Body[0].Nodes.length;i++){
												var depData = data.Body[0].Nodes[i];
												if(depData.DeptName == "营业部"){
													break;
												}
												if (depData.Items != null) {
													depData.Items.sort(function(a,b){
														return a.JobLevel - b.JobLevel
													})
													depData.Items.forEach((userData) => {
														var insertDat = [userData.EmpNo, userData.EmpName]
														item.Values.push(insertDat);
													})
												}
											}
											
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								
								
							})
						});
					}
				})
			},
			getTemplate:async function() {
				this.listLoading = true;
				let that = this;
				var departName = this.logInfo.fullName;
				var depart = departName.split("/").filter(item => item == "住宅部");
				if (depart == null || depart.length <= 0) {
					this.Message({
						message: "没有申请权限",
						type: 'error',
						duration: 3 * 1000
					});
					this.isDisabled = true;
				} else {
					if (this.logInfo.PositionName == "总经理") {
						this.Message({
							message: "没有申请权限",
							type: 'error',
							duration: 3 * 1000
						});
						this.isDisabled = true;
					}
				}
				await getUserInfo(this.logInfo.EmpNo).then(response => {
					userInfo = response.Body.EmployeeInfo;
				});
				getTemplateInfo(this.templateId).then(async response => {
					
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "流程条件") {
							if (this.logInfo.JobLevel <= 3) {
								item.Value = 1;
							} else if (this.logInfo.JobLevel <= 5) {
								item.Value = 2;
							} else if (this.logInfo.JobLevel <= 6) {
								item.Value = 3;
							} else if (this.logInfo.JobLevel <= 7) {
								item.Value = 4;
							} else if (this.logInfo.JobLevel <= 8) {
								item.Value = 5;
							}
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "逐级审批") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门") {
							item.IsShow = true;
							item.Value = "";
						}
						if(item.Property.Title[0].Text == "分行行政"){
							item.IsShow = false;
							item.Values = [];
							getDepartmentRelationByName(userInfo.fullName, false).then(async response => {
								if (response.Body != null && response.Body.length > 0) {
									for (let j = 0; j < response.Body.length; j++) {
										let emps = await that.findEmpByPositionName(response.Body[j].Nodes, "行政助理");
										if (emps.length > 0) {
											item.Values=item.Values.concat(emps)
										}
									}
									if (item.Values == null || item.Values.length == 0) {
										item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "行政主管");
									}
									if (item.Values == null || item.Values.length == 0) {
										item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "行政主任");
									}
								}
								if (item.Values == null || item.Values.length == 0) {
									item.Values = [];
									item.Values.push(that.$store.state.defaultMember);
								}
								
							});
						}

					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val, name) {
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "所在部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control1.Value ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请事项"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				for (var i = 0; i < control2.Config.Selector.Options.length; i++) {
					var data = control2.Config.Selector.Options[i];
					if(data.Key ==control2.Values[0][0]){
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({"Text":"申请事项："+NameOfData,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请原因："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				this.formLoading=true;
				isSubmit = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3*1000
					});
					setTimeout(()=>{this.$router.push("/index");},3000)
				}).finally(()=>{
					isSubmit = false;
					this.formLoading = false;
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
